export const AI_DISCLAIMER = "Generated by AI. Any information provided is not investment advice."

// Pivot guard rail constants
export const MAX_PIVOT_COLUMNS = 3
export const MAX_PIVOT_ROWS = 1000

export const VALUE_FORMATS = {
  PERCENT: "percent",
  PERCENT_100: "percent100",
  NUMBER: "number",
  STRING: "string",
  CURRENCY: "currency",
  PERCENT_10000: "percent10000",
}
